import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import { PBCDetection } from './pbc-detection';
import { PBCDetectionInterface, PBCInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBC')
export class PBC implements PBCInterface {
    @JsonProperty('deteccion', Boolean)
    private _detection: boolean = undefined;

    @JsonProperty('detecciones', [PBCDetection])
    private _detections: PBCDetectionInterface[] = [];

    @JsonProperty('expediente', StringAdapter)
    private _dossier: string = undefined;

    @JsonProperty('fecha', DateAdapter)
    private _date: Moment = undefined;

    @JsonProperty('mensaje', StringAdapter, true)
    private _message?: string = undefined;

    constructor() {
        this._detection = false;
    }

    get detection(): boolean {
        return this._detection;
    }

    get detections(): PBCDetectionInterface[] {
        return this._detections;
    }

    get dossier(): string {
        return this._dossier;
    }

    get date(): Moment {
        return this._date;
    }

    get message(): string {
        return this._message;
    }
}
